import { createSelector } from 'reselect';

import { deliveryStatus as DeliveryStatuses } from 'constants/deliveryStatus';
import { SlotTypes } from 'constants/fulfilmentTypes';
import orderStatus from 'constants/orderStatus';
import { getCustomerOrderById } from 'redux/modules/entities/selectors/customer-orders';
import { isEligibleForDeliveryTracking } from 'redux/modules/order/selectors/is-eligible-for-delivery-tracking';
import { isSignedOnAsCustomer } from 'redux/modules/sessions/selectors';
import {
  cancelledDeliveryTracker,
  completedDeliveryTracker,
  deliveredDeliveryTracker,
  missedDeliveryTracker,
  outForDeliveryTracker,
  preparingDeliveryTracker,
  youreNextDeliveryTracker,
} from '../constants';
import { getDeliveryStatusByOrderId } from './get-delivery-status';

export const getDeliveryTrackerSteps = createSelector(
  getDeliveryStatusByOrderId,
  getCustomerOrderById,
  isSignedOnAsCustomer,
  (deliveryStatusById, order, signedOnAsCustomer) => {
    // eligible for WISMO tracking
    if (
      signedOnAsCustomer ||
      !order.slots[0] ||
      order.slots[0].type === SlotTypes.GROCERY_COLLECTION ||
      order.slots[0].type === SlotTypes.ENTERTAINING_COLLECTION
    ) {
      return null;
    }

    if (isEligibleForDeliveryTracking(order.status, order.slots[0])) {
      if (deliveryStatusById === DeliveryStatuses.OUT_FOR_DELIVERY) {
        return outForDeliveryTracker;
      }
      if (deliveryStatusById === DeliveryStatuses.NEXT) {
        return youreNextDeliveryTracker;
      }
      if (deliveryStatusById === DeliveryStatuses.MISSED) {
        return missedDeliveryTracker;
      }
      if (deliveryStatusById === DeliveryStatuses.DELIVERED) {
        return deliveredDeliveryTracker;
      }
      return preparingDeliveryTracker;
    }
    if (order.status === orderStatus.COMPLETED) {
      return completedDeliveryTracker;
    }
    if (order.status === orderStatus.CANCELLED) {
      return cancelledDeliveryTracker;
    }
    return null;
  },
);
